import Accordion from "@/pages/home/components/Accordion";
import { troubleItems } from "@/mocks/home";

export default function TroubleshootSection() {
  return (
    <section id="troubleshoot" className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
        <div className="lg:col-span-4">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-800 text-xs md:text-sm">
            <i className="ri-tools-line" />
            打不开排查
          </span>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            地址打不开？先按这个顺序排查
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            遇到打不开时，先别急着判断「被封了」。大多数情况只是当前网络或本地缓存的问题，按下面从简单到复杂的顺序逐项尝试，往往一两步就能恢复。
          </p>

          <div className="mt-6 rounded-lg border border-background-200 bg-background-50 p-5">
            <h3 className="font-heading font-bold text-base text-foreground-950 flex items-center gap-2">
              <i className="ri-error-warning-line text-primary-600 text-lg" />
              优先试这两步
            </h3>
            <ol className="mt-3 flex flex-col gap-2 text-sm text-foreground-700">
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-primary-600 mt-0.5" />
                切换 Wi-Fi 与移动数据，刷新页面
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-arrow-right-s-line text-primary-600 mt-0.5" />
                换用另一条备用线路再试一次
              </li>
            </ol>
          </div>
        </div>

        <div className="lg:col-span-8">
          <Accordion items={troubleItems} defaultOpenId="trouble-1" />
        </div>
      </div>
    </section>
  );
}